import {Section} from 'common/components/items-menu/types';
import {EntryPart, QuerySuperEntry} from 'common/widgets/query-entry-section/types';
import type {QueryEntrySection} from 'common/widgets/query-entry-section';

import type {EntryRow, EntryRowProps} from './types';

export abstract class BaseEntryRow<EntryType = QuerySuperEntry> implements EntryRow<EntryType> {
  entry: EntryType;
  section: QueryEntrySection;
  index: number;
  template = null;

  constructor(props: EntryRowProps<EntryType>) {
    this.entry = props.entry;
    this.section = props.section;
    this.index = props.index;
  }

  isPlaceholder() {
    return false;
  }

  overflowControls(): Section[] {
    return [];
  }

  defaultActiveEntryPart(): EntryPart | null {
    if (this.isPlaceholder()) {
      return EntryPart.Value;
    }

    return null;
  }
}
